module.exports = __webpack_public_path__ + "static/media/Dec_2025_5.b2f3ef80.webp";